module.exports = __webpack_public_path__ + "img/trash-icon.c558bb4f.svg";